import { Stack, Box, Skeleton } from '@mui/material';
import {
	cardOrderSX,
	OrderCardHeaderOrderSX,
} from '@/components/content/OrderHistory/parts/History/style/historyOrders';

export const OrderCardSkeleton = () => (
	<Stack sx={cardOrderSX}>
		<Stack direction="row" sx={OrderCardHeaderOrderSX}>
			<Skeleton sx={{ borderRadius: '4px' }} variant="rectangular" width="50%" height={20} />
			<Skeleton sx={{ borderRadius: '4px' }} variant="rectangular" width="30%" height={20} />
		</Stack>
		<Box>
			<Skeleton variant="rectangular" width="100%" height={120} />
		</Box>
	</Stack>
);
